import type {EventName} from '../events';
import {logTmrEvent} from './logTmrEvent';

export const logScrollDepth = (eventName: EventName, scrollDepth: string) => {
  logTmrEvent(eventName, {scrollDepth});
};
